// Lib
import { createAction } from 'redux-actions';

export const GetProducts = createAction('GET_PRODUCTS');
export const SetProducts = createAction('SET_PRODUCTS');
export const ClearProducts = createAction('CLEAR_PRODUCTS');
